import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { UpdateField } from '../action-creators';
import { NEW_TRACK, REMOVE_TRACK_SUCCESS, CREATE_TRACK_SUCCESS } from '../../tracks/actions';
import { trackList } from '@webapp/store/tracks/selectors';

export const updateTrackCountEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action>(
      NEW_TRACK,
      CREATE_TRACK_SUCCESS,
      REMOVE_TRACK_SUCCESS
    ),
    withLatestFrom(state$),
    map(([_, state]) => {
      const tracks = trackList(state.tracks.tracks, state.release.release?.id);

      return new UpdateField<'trackCount'>('trackCount', tracks.length);
    })
  );
  